/**
 * Webpage for drawing the model-Polygons
 */
import React, {Component, createRef} from "react";
import L from "leaflet";
import {Button} from "react-bootstrap";
import {Toast} from "primereact/toast";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from "@fortawesome/free-regular-svg-icons";
import polylabel from "polylabel";

class OutdoorHouseSelection extends Component {
    constructor(props) {
        super(props);
        const next = document.getElementById('next')
        next.classList.add('hover');
        next.classList.remove('fa-disabled');
        next.style.pointerEvents = "auto";
        this.buildings = JSON.parse(localStorage.getItem("buildings"));
        this.buildingLayer = new L.featureGroup();
        this.drawnItems = new L.featureGroup();
        this.buildingSelect = this.buildingSelect.bind(this)
        this.drawStart = this.drawStart.bind(this)
        this.drawingCreated = this.drawingCreated.bind(this)
        this.isMarkerInsidePolygon = this.isMarkerInsidePolygon.bind(this)
        this.heightChange = this.heightChange.bind(this)
        this.deleteAntenna = this.deleteAntenna.bind(this)
        this.nameChange = this.nameChange.bind(this)
        this.calculateCentroid = this.calculateCentroid.bind(this)
        this.checkNext = this.checkNext.bind(this)
        let loadedAntennas = JSON.parse(localStorage.getItem("customAntennas"));
        this.state = {
            customAntennas: loadedAntennas === null ? [] : loadedAntennas,
            visible: false,
        }
        this.toast = createRef()
    }

    /**
     * Same as useEffect
     */
    componentDidMount() {
        //setting up map
        var map = L.map('map', {
            zoom: 0,
        });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            minZoom: 6,
            maxNativeZoom: 18,
            maxZoom: 20,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);
        var drawControl = new L.Control.Draw({
            draw: false,
            edit: {
                edit: false,
                remove: false,
                featureGroup: this.drawnItems,
            },
            tooltip: {'className': 'polygon-tooltip'},
        });
        map.addControl(drawControl);
        this.polygon = L.polygon(JSON.parse(localStorage.getItem("polygon")), {
            color: 'red',
            fill: false
        }).addTo(this.drawnItems);
        if (this.buildings !== null) {
            this.buildings.forEach((building, index) => {
                const centroid = this.calculateCentroid(building.polygon)
                var tooltip = L.tooltip({className: "polygon-tooltip"})
                    .setContent("Höhe: " + Math.round(building.height) + "m")
                let poly = L.polygon(building.polygon, {
                    color: 'grey',
                    fill: true,
                }).bindTooltip(tooltip).addTo(this.buildingLayer)
                tooltip.on('add', function (e) {
                    tooltip.setLatLng(centroid)
                })
                poly.index = index;
                poly.setStyle({
                    color: this.buildings[index].selected ? "red" : "grey"
                });
                poly.on("click", (poly) => this.buildingSelect(poly))
            })
        }
        if (this.state.customAntennas !== null) {
            let temp = [...this.state.customAntennas]
            let antennaCount = 0;
            temp.forEach((antenna, index) => {
                let marker = L.marker(antenna.coords);
                marker.bindTooltip(antenna.name).addTo(this.drawnItems)
                antenna.id = L.stamp(marker)
                antennaCount += 1
            })
            this.antennaCount = antennaCount
            this.setState({customAntennas: temp},
                () => localStorage.setItem("customAntennas", JSON.stringify(this.state.customAntennas))
            )
        }
        map.on(L.Draw.Event.CREATED, (e) => {
            this.drawingCreated(e)
        })
        map.addLayer(this.drawnItems)
        map.fitBounds(this.polygon.getBounds())
        map.addLayer(this.buildingLayer)
        this.map = map
        this.checkNext()
    }

    calculateCentroid(poly) {
        let pts = []
        poly.forEach((p) => {
            pts.push([p.lat, p.lng])
        })
        const p = polylabel([pts], .000005);
        // console.log(p)
        return L.latLng(p[0], p[1]);
    }

    buildingSelect(e) {
        this.buildingLayer.getLayer()
        this.buildings[e.target.index].selected = !this.buildings[e.target.index].selected
        let poly = this.buildingLayer.getLayers()[e.target.index]
        poly.setStyle({
            color: this.buildings[e.target.index].selected ? "red" : "grey"
        });
        localStorage.setItem("buildings", JSON.stringify(this.buildings))
        this.checkNext()
    }

    drawStart(e) {
        var drawMarker = new L.Draw.Marker(this.map);
        drawMarker.enable();
        document.getElementById("addBtn").disabled = true
    }

    isMarkerInsidePolygon(marker, poly) {
        var inside = false;
        var x = marker.getLatLng().lat, y = marker.getLatLng().lng;
        for (var ii = 0; ii < poly.getLatLngs().length; ii++) {
            var polyPoints = poly.getLatLngs()[ii];
            for (var i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
                var xi = polyPoints[i].lat, yi = polyPoints[i].lng;
                var xj = polyPoints[j].lat, yj = polyPoints[j].lng;

                var intersect = ((yi > y) !== (yj > y))
                    && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                if (intersect) inside = !inside;
            }
        }

        return inside;
    };

    drawingCreated(e) {
        var type = e.layerType,
            drawLayer = e.layer;
        if (type === 'marker' && this.isMarkerInsidePolygon(drawLayer, this.polygon)) {
            this.drawnItems.addLayer(drawLayer);
            const antenna = {
                id: L.stamp(drawLayer),
                name: "Antenne",
                coords: [drawLayer.getLatLng().lat, drawLayer.getLatLng().lng],
                height: 5
            }
            drawLayer.bindTooltip(antenna.name);
            this.setState({customAntennas: [...this.state.customAntennas, antenna]},
                () => localStorage.setItem("customAntennas", JSON.stringify(this.state.customAntennas))
            )
            this.antennaCount += 1;
            this.checkNext();
        } else {
            this.toast.current.show({
                life: 5000,
                severity: 'error',
                summary: 'Fehler',
                detail: 'Die Antenne muss sich innerhalb des Polygons befinden!'
            });
        }
        document.getElementById("addBtn").disabled = false

    }

    heightChange(e) {
        var i;
        if (e.target.tagName === "path") {
            i = e.target.parentNode.getAttribute("index")
        } else {
            i = e.target.getAttribute("index")
        }
        let temp = [...this.state.customAntennas]
        temp[i].height = e.target.value
        this.setState({customAntennas: temp}, () => localStorage.setItem("customAntennas", JSON.stringify(this.state.customAntennas)))

    }

    deleteAntenna(e) {
        var i;
        if (e.target.tagName === "path") {
            i = e.target.parentNode.getAttribute("index")
        } else {
            i = e.target.getAttribute("index")
        }
        let temp = [...this.state.customAntennas]
        this.drawnItems.removeLayer(temp[i].id)
        temp.splice(i, 1)
        this.setState({customAntennas: temp}, () => localStorage.setItem("customAntennas", JSON.stringify(this.state.customAntennas)))
        this.antennaCount -= 1;
        this.checkNext();
    }

    nameChange(e) {
        var i;
        if (e.target.tagName === "path") {
            i = e.target.parentNode.getAttribute("index")
        } else {
            i = e.target.getAttribute("index")
        }
        let temp = [...this.state.customAntennas]
        let marker = this.drawnItems.getLayer(temp[i].id)
        marker.bindTooltip(e.target.value)
        temp[i].name = e.target.value
        this.setState({customAntennas: temp}, () => localStorage.setItem("customAntennas", JSON.stringify(this.state.customAntennas)))
    }

    checkNext() {
        const maxAntennaLocations = 100
        // const next = document.getElementById('next')

        // // check buildings
        // let selectedCtr = 0
        // this.buildings.forEach((building, index) => {
        //     if (this.buildings[index].selected)
        //         selectedCtr += 1;
        // });

        // if ((selectedCtr === 0 && this.antennaCount === 0 && this.buildings.length > maxAntennaLocations) || (selectedCtr + this.antennaCount > maxAntennaLocations)) {
        //     // too many buildings
        //     next.classList.add('hover');
        //     next.classList.add('fa-disabled');
        //     next.style.pointerEvents = "none";


        // } else {
        //     next.classList.remove('hover');
        //     next.classList.remove('fa-disabled');
        //     next.style.pointerEvents = "auto";
        // }
    }

    render() {
        return (
            <div>
                <div id={"map"}/>
                <div className={'text-center'}
                     style={{pointerEvents: "none", marginTop: '-140px', position: 'relative', zIndex: '1'}}>
                    <div className={'my-5 px-3 py-1 d-inline-block bg-secondary text-white rounded-3'}
                         style={{pointerEvents: "auto"}}>
                        <div className='fs-4'>Bitte wählen Sie die zu verwendenden Gebäude aus.</div>
                    </div>
                </div>
                <div className={"OverlaySettings shadow-lg px-3 pt-3"} style={{maxHeight: "700px", width: "635px"}}>
                    <div className="fw-bold text-xl text-center">
                        Berücksichtigte Antennenpositionen
                    </div>
                    <div className={"d-flex"}>
                        <ol className="list-group list-group-numbered">
                            <li className="list-group-item d-flex justify-content-between align-items-start border-0">
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold">Alle Gebäude</div>
                                    <div className={"text-justify"}>Wenn keine Gebäude ausgewählt sind, werden alle
                                        Gebäude als mögliche Antennenstandorte betrachtet.
                                        <br/>Achtung! Das führt zu einer langen Berechnungszeit.
                                    </div>
                                </div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start border-0">
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold">Nur ausgewählte (rote) Gebäude</div>
                                    <div className={"text-justify"}>Bitte wählen Sie die gewünschten Gebäude aus, welche
                                        als Antennen-standort betrachtet werden sollen.
                                    </div>
                                </div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start border-0">
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold">Hinzufügen expliziter Antennenpositionen</div>
                                    <div className={"text-justify"}>Fügen Sie Antennenpositionen hinzu, um z.B.
                                        bestehende Masten zu berücksichtigen oder Standorte, die durch OpenStreetMap
                                        nicht richtig erfasst sind zu korrigieren.
                                    </div>
                                </div>
                            </li>
                        </ol>
                    </div>
                    <div className={"d-flex"}>
                        <span className={"m-auto text-xs"}>
                            (Gebäudehöhe wird mit 8m angenommen, wenn keine Information bei OpenStreetMap verfügbar ist.)
                        </span>
                    </div>
                    <table className={"table caption-top customTable"}>
                        <tbody>
                        <tr style={{border: "white"}}>
                            <td className="align-middle">
                                <Button disabled={false} onClick={(e) => {
                                    this.drawStart(e)
                                }} variant="outline-dark btn-dark" id="addBtn" style={{
                                    color: "white",
                                    border: "1px solid #ced4da",
                                    width: "16rem"
                                }}>Antennenposition hinzufügen</Button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="overflow-auto" style={{maxHeight: "250px"}}>
                        <table className="table">
                            <thead style={{
                                background: "white",
                                position: "sticky",
                                top: "0",
                                zIndex: "1",
                                borderBottom: "1px solid black"
                            }}>
                            <tr>
                                <th style={{fontSize: "small"}}>Name</th>
                                <th style={{fontSize: "small"}}>Koordinaten</th>
                                <th style={{fontSize: "small"}}>Höhe</th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.customAntennas.map((row, i) => (
                                <tr key={i}>
                                    <td style={{fontSize: "small"}}>
                                        <input className="form-control align-middle" name="name"
                                               id="name" index={i}
                                               value={row.name} style={{fontSize: "small"}}
                                               onChange={this.nameChange}/>
                                    </td>
                                    <td className="align-middle" style={{fontSize: "small"}}>
                                        {Math.round(row.coords[0]*10000000)/10000000 + ", " + Math.round(row.coords[1]*10000000)/10000000}
                                    </td>
                                    <td>
                                        <input className="form-control align-middle" type="number"
                                               name="height"
                                               id="height" index={i}
                                               min="1" max="50" step=".5"
                                               value={row.height} style={{fontSize: "small"}}
                                               onChange={this.heightChange}/>
                                    </td>
                                    <td className="align-middle">
                                        <FontAwesomeIcon index={i}
                                                         onClick={this.deleteAntenna}
                                                         className='hover'
                                                         icon={faTrashAlt} size="1x"
                                                         id={'delete_' + i}/>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>

                </div>
                <Toast ref={this.toast}/>
            </div>
        )
    };
}

export default OutdoorHouseSelection;
